import { render } from "./StackedPercentageChart.vue?vue&type=template&id=696fe576&ts=true"
import script from "./StackedPercentageChart.vue?vue&type=script&lang=ts"
export * from "./StackedPercentageChart.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__